import { FC } from 'react'
import { Description, VStack } from '@revolut-internal/ui-kit'

import { AiDebugProcess, TraceActionClient } from 'lib/apiClient'

import { OpenAIChat } from './OpenAIChat'
import { PtolemySearchLinks } from './PtolemySearchLinks'
import { ParamsTable } from './ParamsTable'

type Props = AiDebugProcess['traces'][number]

export const TraceAction: FC<Props> = props => {
  switch (props.client) {
    case TraceActionClient.OpenAIChat:
      return <OpenAIChat {...props} />
  }

  return (
    <VStack>
      {props.client === TraceActionClient.PtolemySearchClient && (
        <PtolemySearchLinks data={props.clientOutput.data} />
      )}
      <Description>Client input:</Description>
      <ParamsTable
        data={props.humanReadableInput ?? props.clientInput}
        markdown={Boolean(props.humanReadableInput)}
        chatUiRenderMethod={
          props.client === TraceActionClient.OpenAIModerator ||
          props.client === TraceActionClient.ModerationClient
        }
      />
      <Description>Client output:</Description>
      <ParamsTable
        data={props.humanReadableOutput ?? props.clientOutput}
        markdown={Boolean(props.humanReadableOutput)}
      />
    </VStack>
  )
}
